var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "loader",
    { attrs: { loading: _vm.loading, size: 40 } },
    [
      _c(
        "md-layout",
        [
          _c(
            "md-switch",
            {
              staticClass: "md-primary",
              model: {
                value: _vm.ads.dfpEnabled,
                callback: function($$v) {
                  _vm.$set(_vm.ads, "dfpEnabled", $$v)
                },
                expression: "ads.dfpEnabled"
              }
            },
            [_vm._v("Use DCM or DFP")]
          )
        ],
        1
      ),
      _vm.ads.dfpEnabled
        ? _c(
            "md-layout",
            [
              _c(
                "md-input-container",
                [
                  _c("label", { attrs: { for: "network" } }, [
                    _vm._v("Network")
                  ]),
                  _c(
                    "md-select",
                    {
                      attrs: {
                        id: "network",
                        disabled: _vm.networks.length < 2
                      },
                      model: {
                        value: _vm.ads.networkCode,
                        callback: function($$v) {
                          _vm.$set(_vm.ads, "networkCode", $$v)
                        },
                        expression: "ads.networkCode"
                      }
                    },
                    _vm._l(_vm.networks, function(network) {
                      return _c(
                        "md-option",
                        {
                          key: network.networkCode,
                          attrs: { value: network.networkCode },
                          on: { selected: _vm.onNetworkSelected }
                        },
                        [_vm._v(_vm._s(network.displayName))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", { attrs: { for: "advertiser" } }, [
                            _vm._v("Advertiser")
                          ]),
                          _c(
                            "md-select",
                            {
                              attrs: {
                                id: "advertiser",
                                disabled: _vm.advertisers.length == 0
                              },
                              model: {
                                value: _vm.ads.advertiserId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ads, "advertiserId", $$v)
                                },
                                expression: "ads.advertiserId"
                              }
                            },
                            _vm._l(_vm.advertisers, function(advertiser) {
                              return _c(
                                "md-option",
                                {
                                  key: advertiser.id,
                                  attrs: { value: advertiser.id },
                                  on: { selected: _vm.onAdvertiserSelected }
                                },
                                [_vm._v(_vm._s(advertiser.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.loadingAdvertisers
                    ? _c(
                        "md-layout",
                        {
                          staticClass: "select-loader",
                          attrs: { "md-flex": "10", "md-align": "end" }
                        },
                        [
                          _c("md-spinner", {
                            staticClass: "md-accent",
                            attrs: { "md-indeterminate": "", "md-size": 25 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", { attrs: { for: "order" } }, [
                            _vm._v("Order")
                          ]),
                          _c(
                            "md-select",
                            {
                              attrs: {
                                id: "order",
                                disabled: _vm.orders.length == 0
                              },
                              model: {
                                value: _vm.ads.orderId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ads, "orderId", $$v)
                                },
                                expression: "ads.orderId"
                              }
                            },
                            _vm._l(_vm.orders, function(order) {
                              return _c(
                                "md-option",
                                {
                                  key: order.id,
                                  attrs: { value: order.id },
                                  on: { selected: _vm.onOrderSelected }
                                },
                                [_vm._v(_vm._s(order.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.loadingOrders
                    ? _c(
                        "md-layout",
                        {
                          staticClass: "select-loader",
                          attrs: { "md-flex": "10", "md-align": "end" }
                        },
                        [
                          _c("md-spinner", {
                            staticClass: "md-accent",
                            attrs: { "md-indeterminate": "", "md-size": 25 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", { attrs: { for: "lineItem" } }, [
                            _vm._v("Line Item")
                          ]),
                          _c(
                            "md-select",
                            {
                              attrs: {
                                id: "order",
                                disabled: _vm.lineItems.length == 0
                              },
                              model: {
                                value: _vm.ads.lineItemId,
                                callback: function($$v) {
                                  _vm.$set(_vm.ads, "lineItemId", $$v)
                                },
                                expression: "ads.lineItemId"
                              }
                            },
                            _vm._l(_vm.lineItems, function(lineItem) {
                              return _c(
                                "md-option",
                                {
                                  key: lineItem.id,
                                  attrs: { value: lineItem.id },
                                  on: { selected: _vm.onLineItemSelected }
                                },
                                [_vm._v(_vm._s(lineItem.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.loadingLineItems
                    ? _c(
                        "md-layout",
                        {
                          staticClass: "select-loader",
                          attrs: { "md-flex": "10", "md-align": "end" }
                        },
                        [
                          _c("md-spinner", {
                            staticClass: "md-accent",
                            attrs: { "md-indeterminate": "", "md-size": 25 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "md-layout",
                { attrs: { "md-flex": "100" } },
                [
                  _c(
                    "md-layout",
                    [
                      _c(
                        "md-input-container",
                        [
                          _c("label", { attrs: { for: "adUnit" } }, [
                            _vm._v("Ad Unit")
                          ]),
                          _c(
                            "md-select",
                            {
                              attrs: {
                                id: "adUnit",
                                disabled: _vm.adUnits.length == 0
                              },
                              on: { selected: _vm.setAdUnitId },
                              model: {
                                value: _vm.ads.adUnitTag,
                                callback: function($$v) {
                                  _vm.$set(_vm.ads, "adUnitTag", $$v)
                                },
                                expression: "ads.adUnitTag"
                              }
                            },
                            _vm._l(_vm.adUnits, function(adUnit) {
                              return _c(
                                "md-option",
                                {
                                  key: adUnit.tag,
                                  attrs: { value: adUnit.tag }
                                },
                                [_vm._v(_vm._s(adUnit.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.loadingAdUnits
                    ? _c(
                        "md-layout",
                        {
                          staticClass: "select-loader",
                          attrs: { "md-flex": "10", "md-align": "end" }
                        },
                        [
                          _c("md-spinner", {
                            staticClass: "md-accent",
                            attrs: { "md-indeterminate": "", "md-size": 25 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b70d374", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b70d374","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/Dfp.vue
// module id = 756
// module chunks = 0